import React from "react";
import styles from '../../styles/layout/Footer.module.css';

const Footer = () => {
    return (
        <div className={styles.footer}>
            <div className={styles.left}>
                <div className={styles.main}>
                    <p>(주) 오퍼그룹</p>
                    <div className={styles.icons}>
                        <a href="https://www.instagram.com/offer__group/" target="_blank" rel="noopener noreferrer"><img src={`${process.env.PUBLIC_URL}/main/8p/instagram.png`} alt="인스타그램"/></a>
                        <a href="https://blog.naver.com/bni_binkyung" target="_blank" rel="noopener noreferrer"><img src={`${process.env.PUBLIC_URL}/main/8p/naver_blog.png`} alt="네이버 블로그"/></a>
                        <a href="https://youtube.com" target="_blank" rel="noopener noreferrer"><img src={`${process.env.PUBLIC_URL}/main/8p/youtube.png`} alt="유튜브"/></a>
                    </div>
                </div>
                <div className={styles.sub}>
                    <p>대표자명 : 설빈경</p>
                    <p>사업자등록번호 : 644-87-02089</p>
                    <p>전화 : 1544-3230</p>
                    <p>본사 주소 : 경기 부천시 원미구 조마루로385번길 92, 부천테크노벨리u1센터 1013호, 1014호, 1015호</p>
                </div>
            </div>
            <div className={styles.divider}></div>
            <div className={styles.right}>
                <img src={`${process.env.PUBLIC_URL}/main/8p/headset.png`} alt="헤드셋" />
                <span>1544-3230</span>
                <p>09:00 ~ 18:00</p>
            </div>
        </div>
    )
}

export default Footer;